import { render } from "./PromosView.vue?vue&type=template&id=480f692c"
import script from "./PromosView.vue?vue&type=script&lang=js"
export * from "./PromosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__